import { Modal, Typography } from "antd"
import React, { useState } from "react"

const { Link } = Typography

export default function AdminCommentModal({ data }) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const lastAdminRequest =
    data.adminRequests && data.adminRequests.length > 0
      ? data.adminRequests[data.adminRequests.length - 1]
      : null

  const showModal = () => {
    setIsModalOpen(true)
  }
  const handleOk = () => {
    setIsModalOpen(false)
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }
  return (
    <div>
      <Link type="primary" onClick={showModal}>
        View Administrator comment
      </Link>
      <Modal
        title="Administrator Comment"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}>
        {lastAdminRequest ? lastAdminRequest.requestComment : "No Comment"}
      </Modal>
    </div>
  )
}
